import React, {useEffect, useRef} from 'react'
import './StickyHighlightsSection.css'
import lottie from 'lottie-web'
import { MouseParallaxContainer, MouseParallaxChild } from "react-parallax-mouse";
import BangkokImageOne from '../../assets/images/gallery-0000-bangkok-image-min.jpg'
import BangkokImageFour from '../../assets/images/gallery-0003-bangkok-image-min.jpg'
import LondonImageOne from '../../assets/images/gallerylondon-0000-london-image-min.jpg'
import LondonImageTwo from '../../assets/images/gallerylondon-0001-london-image-min.jpg'
import LasVegasImageOne from '../../assets/images/gallery-images-0000-las-vegas.jpg'
import LasVegasImageTwo from '../../assets/images/gallery-images-0001-las-vegas.jpg'
import LasVegasImageFour from '../../assets/images/gallery-images-0003-las-vegas.jpg'


const StickyHighlightsSection = () => {

    //create array of images
    const bangkokImages = [BangkokImageOne, BangkokImageFour, BangkokImageOne, BangkokImageFour]
    const londonImages = [LondonImageOne, LondonImageTwo, LondonImageOne, LondonImageTwo]
    const lasVegasImages = [LasVegasImageOne, LasVegasImageTwo, LasVegasImageFour, LasVegasImageOne, LasVegasImageTwo, LasVegasImageFour]

    //map through vegas images and create an li for each image
    const bangkokImagesLis = bangkokImages.map((image, index) => {
        return (
            <li className='el-item uk-width-1-1' key={index}>
                <img src={image} alt='bangkok' className='bangkok-image border-round' />
            </li>
        )
    });

    const londonImagesLis = londonImages.map((image, index) => {
        return (
            <li className='el-item uk-width-1-1' key={index}>
                <img src={image} alt='london' className='london-image border-round' />
            </li>
        )
    });

    const lasVegasImagesLis = lasVegasImages.map((image, index) => {
        return (
            <li className='el-item uk-width-1-1' key={index}>
                <img src={image} alt='las vegas' className='las-vegas-image border-round' />
            </li>
        )
    });
    

    const chilliAnimationRef = useRef(null);
    const chipsAnimationRef = useRef(null);
    const kettleAnimationRef = useRef(null);
    const cupAnimationRef = useRef(null);

    useEffect (() => {

        const cameraAnimation = lottie.loadAnimation({
            container: chilliAnimationRef.current,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: require('../../lottie/chilli-loop-optimized.json'),
            rendererSettings: {
                preserveAspectRatio: "xMidYMid slice",
              }
        });


        const chipsAnimation = lottie.loadAnimation({
            container: chipsAnimationRef.current,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: require('../../lottie/chipswhite-loop-optimized'),
            rendererSettings: {
                preserveAspectRatio: "xMidYMid slice",
              }
        });

        const kettleAnimation = lottie.loadAnimation({
            container: kettleAnimationRef.current,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: require('../../lottie/kettle-loop-optimized.json'),
            rendererSettings: {
                preserveAspectRatio: "xMidYMid slice",
                }
        });

        const cupAnimation = lottie.loadAnimation({
            container: cupAnimationRef.current,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: require('../../lottie/cup-loop-optimized.json'),
            rendererSettings: {
                preserveAspectRatio: "xMidYMid slice",
                }
        });


    }, [])








  return (
    <>
    
<MouseParallaxContainer> 
<div className="uk-section-default uk-section uk-padding-remove-vertical">


    <div className="tm-grid-expand uk-grid-margin uk-grid" uk-grid="">


 {/* Start of Left Grid */}
<div className="uk-width-1-2@m uk-flex-first">

<div className="uk-visible@m trip-background-mustard uk-position-z-index uk-tile uk-padding-remove uk-flex uk-flex-middle uk-sticky" uk-height-viewport="offset-top: true;" uk-sticky="end: !.uk-section;" >    
        <div className="uk-panel uk-width-1-1">            
             <div className="uk-grid-margin uk-container uk-container-xsmall">
                <div id="page#1" className=" uk-child-width-1-1 uk-grid uk-grid-stack" uk-grid="">
                    <div className="uk-width-1-1 uk-first-column" uk-scrollspy="cls:uk-animation-slide-bottom-medium; repeat: true">

                    <div className="uk-panel uk-margin padding-xl trip-heading-one">
                    Those simple searches took us all over the world—but it was the bigger cities that really drew us in.
                    </div>
        
                </div>
            </div>
        </div>
        
    </div>
</div>


<div className="uk-hidden@m trip-background-mustard top-z uk-tile uk-padding uk-flex uk-flex-middle uk-sticky" uk-sticky="end: !.uk-section;" >    
        <div className="uk-panel uk-width-1-1">            
             <div className="uk-grid-margin ">
                <div id="page#1" className="tm-grid-expand uk-child-width-1-1 uk-grid uk-grid-stack" uk-grid="">
                    <div className="uk-width-1-1 uk-first-column">

                    <div className="uk-panel uk-margin trip-heading-one">
                    Those simple searches took us all over the world—but it was the bigger cities that really drew us in.
                    </div>
        
                </div>
            </div>
        </div>
        
    </div>
</div>



</div>
{/* End of Left Stcky Grid */}       


{/* Left Grid */}
       <div className="uk-width-1-2@m uk-flex-first@l uk-first-column uk-margin-large-bottom" id="page#0">
            <div className="uk-flex uk-flex-middle" uk-height-viewport="offset-top: true;" >  

				<div className="uk-panel uk-width-1-1"> 


{/* Section One */}
                <div className="uk-margin uk-container uk-container-xsmall">
                    <div className="tm-grid-expand uk-child-width-1-1 uk-grid uk-grid-stack" uk-grid="">
                        <div className="uk-width-1-1 uk-first-column">
                            <div className="uk-flex uk-flex-middle uk-height-viewport"> 
                                <div id="bangkok-start-end" className="uk-panel uk-width-1-1">

                                <div className='sticky-slider-container z-5'>


                                    <div className=" uk-text-center z-5 sticky-slider sticky-gallery-image">
                                            <div className=" uk-text-center uk-slider uk-slider-container " tabIndex="-1" uk-slider="autoplay: true; center: true; autoplay-interval: 2000" >
                                                <div className="uk-position-relative border-round">
                                                    <ul className="uk-slider-items uk-grid uk-grid-small" style={{transform: "translate3d(-125.875px, 0px, 0px)"}}>                                
                                                            
                                                            {bangkokImagesLis}

                                                    </ul>
                                                </div>
                                            </div>
                                     </div>
                                     </div>

                                    <div className='bangkok-hotels  z-10' >
                                    <MouseParallaxChild factorX={0.05} factorY={0.05}>  
                                        <div className='highlight-cards bangkok-card'>
                                         
                                            <span className='trip-ultra'>11MM</span> traveler searches <br/> for Bangkok
                                        </div>
                                    </MouseParallaxChild>
                                    </div>

                                    <MouseParallaxChild factorX={-0.09} factorY={-0.05}>
                                        <div>
                                        
                                            <div className='chilliContainer' ref={chilliAnimationRef }> </div>
                                        
                                        </div> 
                                    </MouseParallaxChild> 
                
                                </div>
    
                            </div>
                        </div>
                    </div>
                </div>

{/* End of Section One */}



{/* Section Two London */}
<div className="uk-margin uk-container uk-container-xsmall">
                    <div className="tm-grid-expand uk-child-width-1-1 uk-grid uk-grid-stack" uk-grid="">
                        <div className="uk-width-1-1 uk-first-column">
                            <div className="uk-flex uk-flex-middle" uk-height-viewport="offset-top: true;" >     
                                 <div className="uk-panel uk-width-1-1">   
                                <div className='sticky-slider-container z-5'>


                                    <div className=" uk-text-center z-5 sticky-slider sticky-gallery-image">
                                            <div className=" uk-text-center uk-slider uk-slider-container " tabIndex="-1" uk-slider="autoplay: true; center: true; autoplay-interval: 2000" >
                                                <div className="uk-position-relative border-round">
                                                    <ul className="uk-slider-items uk-grid uk-grid-small" style={{transform: "translate3d(-125.875px, 0px, 0px)"}}>                                
                                                            
                                                            {londonImagesLis}

                                                    </ul>
                                                </div>
                                            </div>
                                     </div>
                                     </div>
                                
                                    <div className='bangkok-hotels z-10'>
                                    <MouseParallaxChild factorX={0.05} factorY={0.05}>
                                        <div className='highlight-cards bangkok-card'>
                                        
                                            <span className='trip-ultra'>43.6MM </span> traveler searches <br/>for London
                                        </div>
                                    </MouseParallaxChild>
                                    </div>

                                    <MouseParallaxChild factorX={-0.09} factorY={-0.05}>
                                    <div className='kettleContainer'>
                                         <div className='' ref={kettleAnimationRef}> </div>
                                    </div>  
                                     </MouseParallaxChild>

                                     <MouseParallaxChild factorX={0.05} factorY={-0.06}>
                                     <div className=''>
                                         <div className='cupContainer' ref={cupAnimationRef}> </div>
                                        
                                    </div>   
                                    </MouseParallaxChild>
                         

                                </div>
                            
                            </div>
                        </div>
                    </div>
                </div>
 {/* End of Section Two London */}    




{/* Section Three Vegas */}
                <div className="uk-margin uk-container uk-container-xsmall oveflowY-visible">
                    <div className="tm-grid-expand uk-child-width-1-1 uk-grid uk-grid-stack" uk-grid="">
                        <div className="uk-width-1-1 uk-first-column">
                            <div className="uk-flex uk-flex-middle uk-height-viewport">    
                                <div className="uk-panel uk-width-1-1">
                               
                                    <div className='sticky-slider-container z-5'>
                                            <div className=" uk-text-center z-5 sticky-slider sticky-gallery-image">
                                                    <div className=" uk-text-center uk-slider uk-slider-container " tabIndex="-1" uk-slider="autoplay: true; center: true; autoplay-interval: 2000" >
                                                        <div className="uk-position-relative border-round">
                                                            <ul className="uk-slider-items uk-grid uk-grid-small" style={{transform: "translate3d(-125.875px, 0px, 0px)"}}>                                
                                                                    
                                                                   {lasVegasImagesLis}

                                                            </ul>
                                                        </div>
                                                    </div>
                                            </div>
                                    </div>
                                    
                                    <div className='bangkok-hotels z-10'>
                                        <MouseParallaxChild factorX={0.05} factorY={0.05}> 
                                            <div className=' highlight-cards bangkok-card'>
                                              
                                                <span className='trip-ultra'> 20.2MM</span> traveler searches <br/>for Las Vegas
                                            </div>
                                        </MouseParallaxChild>
                                    </div>
                                   
                                    <div className=''>
                                    <MouseParallaxChild factorX={-0.07} factorY={-0.03}>
                                         <div className='chipsContainer' ref={chipsAnimationRef}> </div>
                                         </MouseParallaxChild>
                                    </div>       


                                </div>
                            </div>
                    
                        </div>
                    </div>
                </div>

{/* End of Section Three Vegas */}




                
        </div>
    </div>
</div>
{/* End of Left Grid */}




{/* Right Grid */}
{/* <div className="uk-width-1-2@m uk-flex-first">

        <div className="uk-visible@m trip-background-mustard uk-position-z-index uk-tile uk-padding-remove uk-flex uk-flex-middle uk-sticky" uk-height-viewport="offset-top: true;" uk-sticky="end: !.uk-section;" >    
                <div className="uk-panel uk-width-1-1">            
                     <div className="uk-grid-margin uk-container uk-container-xsmall">
                        <div id="page#1" className="tm-grid-expand uk-child-width-1-1 uk-grid uk-grid-stack" uk-grid="">
                            <div className="uk-width-1-1 uk-first-column">
    
                            <div className="uk-panel uk-margin padding-xl trip-heading-one">
                            Those simple <span className='trip-ultra'> searches  </span> 
                            took us all over the <span className='trip-ultra'> world— </span>but it was the bigger cities that really drew us in.
                            </div>
                
                        </div>
                    </div>
                </div>
                
            </div>
        </div>


        <div className="uk-hidden@m trip-background-mustard top-z uk-tile uk-padding uk-flex uk-flex-middle uk-sticky" uk-sticky="end: !.uk-section;" >    
                <div className="uk-panel uk-width-1-1">            
                     <div className="uk-grid-margin ">
                        <div id="page#1" className="tm-grid-expand uk-child-width-1-1 uk-grid uk-grid-stack" uk-grid="">
                            <div className="uk-width-1-1 uk-first-column">
    
                            <div className="uk-panel uk-margin trip-heading-one">
                            Those simple <span className='trip-ultra'> searches  </span> 
                            took us all over the <span className='trip-ultra'> world— </span>but it was the bigger cities that really drew us in.
                            </div>
                
                        </div>
                    </div>
                </div>
                
            </div>
        </div>






        
    
</div> */}
{/* End of Right Grid */}




    </div>




</div>

</MouseParallaxContainer> 
</>
  )
}

export default StickyHighlightsSection